"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const utils_1 = require("@/common/utils/utils");
const PlanetaryTrackRewards_vue_1 = require("./PlanetaryTrackRewards.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'PlanetaryTrack',
    props: {
        val: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        rewards: {
            type: Object,
            required: true,
        },
        gameOptions: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            range: (0, utils_1.range)(23),
        };
    },
    components: {
        PlanetaryTrackRewards: PlanetaryTrackRewards_vue_1.default,
    },
    methods: {
        getClass(idx) {
            return (idx === this.val) ? 'highlight' : '';
        },
    },
    computed: {
        icon() {
            switch (this.type) {
                case 'risingPlayer': return '^';
                case 'everyone': return '*';
                case 'mostTags': return '!';
                default: return '';
            }
        },
    },
});
